// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Iframe_wrap__2g0-T","loader":"Iframe_loader__112Wa","iframe":"Iframe_iframe__3EE_a","iframe_loading":"Iframe_iframe_loading__2BmI0"};